export default [
  {
    name: 'Economics',
    description:
      'Economics, in all its multitude of approaches and trends, is my passion that has been developing since high school when I participated in the Olympiad. Curiosity about how a state can be managed became the inspiration for creating my political testing platform, Soulgraphy.',
    image: 'kanada',
  },
  {
    name: 'Nature and the Animal World',
    description:
      'From an early age, I have been fascinated by the animal world and the environment they live in. As a child, I wanted to become a zoologist.',
    image: 'seal',
  },
  {
    name: 'Countries of the World',
    description:
      'Every year, I am more and more fascinated by delving into knowledge about different parts of the world. How languages have shaped over time helps to better understand the culture and mindset of people from different countries. By diving into their history, it is easier to see what influences how their present looks. I am particularly interested in the Nordic countries and Japan.',
    image: 'japan',
  },
  {
    name: 'Electronic Technologies',
    description:
      'Electronics, programming, and telecommunication technologies are not just interesting fields of science to me. Above all, they are tools that allow me to feel like an inventor and independently create my own electronic circuits or web applications.',
    image: 'telecommunications',
  },
  {
    name: 'Physics and Technology',
    description:
      'I have always been curious about how the world works. It does not matter if it is the current in a light bulb or why the sun shines. Physics to me is the process of getting to know the world and understanding why it behaves the way it does. Using this knowledge gives brilliant minds the tools to create innovative solutions that change the world before our eyes — from cheap and clean energy, through efficient batteries, to life-saving drugs.',
    image: 'physics',
  },
  {
    name: 'Cooking',
    description:
      'I love cooking and experimenting in the kitchen, and preparing pasta or meat is a regular part of my day. Apart from Polish cuisine, I love Korean and Indian dishes.',
    image: 'cooking',
  },
  {
    name: 'Fantasy, Games, and Relaxation',
    description:
      'Nobody in their right mind comes back from work to another job, because everyone needs to relax and take time away from everyday life. When I do, I usually watch movies, explore (and write) fantasy, go on road trips, or play all sorts of games with friends.',
    image: 'relax',
  },
]
